import { render, staticRenderFns } from "./SelectedSurgeryInfo.vue?vue&type=template&id=2afc961e&"
import script from "./SelectedSurgeryInfo.vue?vue&type=script&lang=js&"
export * from "./SelectedSurgeryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports